module.exports = __webpack_public_path__ + "static/media/credentialing-vendors.a2dda984.svg";